import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiService {
  api: string;

  constructor(private http: HttpClient) {
    this.api = environment.apiUrl;
  }

  postLead(data) {
    return this.http.post(this.api + 'SMSLead/', data);
  }

  editPhone(id, data) {
    return this.http.put(this.api + 'leads/' + id, data);
  }

  getLocation(query): any {
    return this.http.get(this.api + 'location/' + query);
  }

  getLocationName(query): any {
    return this.http.get(this.api + 'locationName/' + query);
  }

  sendSMS(id): any {
    return this.http.get(this.api + 'SMS/' + id);
  }

  sendCall(id): any {
    return this.http.get(this.api + 'call/' + id);
  }

  verify(id, data): any {
    return this.http.post(this.api + 'verify/' + id, data);
  }


  postLeadFinance(data) {
    return this.http.post(this.api + 'finance/SMSLead/', data);
  }

  editPhoneFinance(id, data) {
    return this.http.put(this.api + 'finance/leads/' + id, data);
  }

  getLocationFinance(query): any {
    return this.http.get(this.api + 'finance/location/' + query);
  }

  sendSMSFinance(id): any {
    return this.http.get(this.api + 'finance/SMS/' + id);
  }

  sendCallFinance(id): any {
    return this.http.get(this.api + 'finance/call/' + id);
  }

  verifyFinance(id, data): any {
    return this.http.post(this.api + 'finance/verify/' + id, data);
  }

  putPrivacyFinance(id, data): any {
    return this.http.put(this.api + 'finance/privacy/' + id, data);
  }

  getPrivacyFinance(id): any {
    return this.http.get(this.api + 'finance/privacy/' + id);
  }

  setupFinance(job, zipcode, type, affiliate, oldBuyers, birthday, amount, layoff, closedCQ): any {
    return this.http.post(this.api + 'finance/setup/', { job, zipcode, type, affiliate, oldBuyers, birthday, amount, layoff, closedCQ });
  }


  getBuyer(id, type, affiliate): any {
    return this.http.post(this.api + 'finance/buyer/', { id, type, affiliate });
  }


  setupFinanceTop(lead): any {
    return this.http.post(this.api + 'finance/setup/', lead).toPromise();
  }

  registerClick(id, buyer): any {
    return this.http.post(this.api + 'finance/click/' + id, { buyer });
  }



  postLeadNLT(data) {
    return this.http.post(this.api + 'NLT/SMSLead/', data);
  }

  editPhoneNLT(id, data) {
    return this.http.put(this.api + 'NLT/leads/' + id, data);
  }

  getLocationNLT(query): any {
    return this.http.get(this.api + 'NLT/location/' + query);
  }

  sendSMSNLT(id): any {
    return this.http.get(this.api + 'NLT/SMS/' + id);
  }

  sendCallNLT(id): any {
    return this.http.get(this.api + 'NLT/call/' + id);
  }

  verifyNLT(id, data): any {
    return this.http.post(this.api + 'NLT/verify/' + id, data);
  }

  setupNLT(zipcode, type, affiliate, oldBuyers): any {
    return this.http.post(this.api + 'NLT/setup/', { zipcode, type, affiliate, oldBuyers });
  }

  getBuyerNLT(id, affiliate): any {
    return this.http.post(this.api + 'NLT/buyer/', { id, affiliate });
  }





  postLeadLoan(data) {
    return this.http.post(this.api + 'loan/SMSLead/', data);
  }

  editPhoneLoan(id, data) {
    return this.http.put(this.api + 'loan/leads/' + id, data);
  }

  getLocationLoan(query): any {
    return this.http.get(this.api + 'loan/location/' + query);
  }

  sendSMSLoan(id): any {
    return this.http.get(this.api + 'loan/SMS/' + id);
  }

  sendCallLoan(id): any {
    return this.http.get(this.api + 'loan/call/' + id);
  }

  verifyLoan(id, data): any {
    return this.http.post(this.api + 'loan/verify/' + id, data);
  }

  setupLoan(zipcode, affiliate, oldBuyers, purpose, length): any {
    return this.http.post(this.api + 'loan/setup/', { zipcode, affiliate, oldBuyers, purpose, length });
  }

}
